"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleModelDataMain = void 0;
/* eslint-disable max-len */
/* eslint-disable default-case */
const core_1 = require("@angular/core");
const config_service_1 = require("../../../../../shared/config/config.service");
const enums_1 = require("../../../@shared-types/vehicle/enums");
let VehicleModelDataMain = class VehicleModelDataMain {
    constructor(configService) {
        this.configService = configService;
        this.selectOptions = {};
        this.fuelChange = (newFuel) => {
            switch (newFuel) {
                case enums_1.EFuelType.HybridDieselPlugin:
                case enums_1.EFuelType.HybridPetrolPlugin:
                case enums_1.EFuelType.HybridDieselMild:
                case enums_1.EFuelType.HybridFull:
                case enums_1.EFuelType.HybridPetrolMild:
                    this.modelData.engine.fuel.hybrid = true;
                    break;
                default:
                    delete this.modelData.engine.fuel.hybrid;
                    break;
            }
            this.modelData.engine.fuel.type = newFuel;
        };
        this.isEV = () => {
            var _a;
            if (((_a = this.modelData) === null || _a === void 0 ? void 0 : _a.engine.fuel.type) === enums_1.EFuelType.Electricity)
                return true;
            return false;
        };
        this.isPHEV = () => {
            var _a;
            switch ((_a = this.modelData) === null || _a === void 0 ? void 0 : _a.engine.fuel.type) {
                case enums_1.EFuelType.HybridDieselPlugin:
                case enums_1.EFuelType.HybridPetrolPlugin:
                    return true;
                default: return false;
            }
        };
        this.selectOptions = {
            vehicleClass: this.configService.getConstant(config_service_1.ConstantTypes.VEHICLE_CLASS),
            vehicleCategory: this.configService.getConstant(config_service_1.ConstantTypes.VEHICLE_CATEGORY),
            vehicleManufacturer: this.configService.getConstant(config_service_1.ConstantTypes.VEHICLE_MANUFACTURER),
            fuelTypes: this.configService.getConstant(config_service_1.ConstantTypes.FUEL_TYPES),
            drivetrainTypes: this.configService.getConstant(config_service_1.ConstantTypes.DRIVETRAIN_TYPES),
            transmissionTypes: this.configService.getConstant(config_service_1.ConstantTypes.TRANSMISSION_TYPES),
            doorCount: this.configService.getConstant(config_service_1.ConstantTypes.DOOR_COUNT),
            slidingDoors: this.configService.getConstant(config_service_1.ConstantTypes.SLIDING_DOORS),
            plugTypes: this.configService.getConstant(config_service_1.ConstantTypes.PLUG_TYPES),
            bidirectionalChargingTypes: this.configService.getConstant(config_service_1.ConstantTypes.BIDIRECTIONAL_CHARGING_TYPES),
        };
    }
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], VehicleModelDataMain.prototype, "modelData", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], VehicleModelDataMain.prototype, "importResult", void 0);
VehicleModelDataMain = __decorate([
    (0, core_1.Component)({
        selector: 'model-data-main',
        templateUrl: require('./main.component.html'),
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof config_service_1.ConfigService !== "undefined" && config_service_1.ConfigService) === "function" ? _a : Object])
], VehicleModelDataMain);
exports.VehicleModelDataMain = VehicleModelDataMain;
